import { parseJsonSafe } from '@feedyou/utils'
import { LlmChatOutputToolCall } from '@feedyou/utils'

type ToolCall = { tool: string; args?: string }
type LlmToolCall = LlmChatOutputToolCall<'completion'> | LlmChatOutputToolCall<'responses'>

export function parseQueryOutputToolCalls(
  toolCalls: undefined | string | LlmToolCall[]
): ToolCall[] {
  const array =
    typeof toolCalls === 'object' ? toolCalls : parseJsonSafe<LlmToolCall[]>(toolCalls || '[]')

  if (!array?.length) return []

  return array.map(getToolCallValues)
}

export function isLlmChatResponseToolCall(
  call: LlmToolCall
): call is LlmChatOutputToolCall<'completion'> {
  return call?.type === 'function'
}

function getToolCallValues(call: LlmToolCall): ToolCall {
  function parseArgs(args: object | string | undefined = {}) {
    // args are typed as string, come in as object. Not sure if this is always - better safe than sorry.
    // If you want to debug and solve this the right way, you are more than welcome.
    const argsStringified: string = typeof args === 'string' ? args : JSON.stringify(args)
    return argsStringified === '{}' ? '' : argsStringified
  }

  if (isLlmChatResponseToolCall(call)) {
    return {
      tool: call.function?.name || '',
      args: parseArgs(call.function?.arguments)
    }
  }

  return {
    tool: call.name || '',
    args: parseArgs(call.arguments)
  }
}
